function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import Cookies from 'js-cookie';
var ATTRIBUTION_COOKIE = 'rw_attribution';
var ATTRIBUTION_KEYS = ['utm_source', 'gclid', 'fbclid', 'referrer'];
/**
 * Reads the first-touch attribution cookie (`rw_attribution`) planted on
 * `.restworld.it` by the marketing site and returns the subset of fields the
 * org-create payload accepts.
 *
 * The cookie is the cross-subdomain bridge: the marketing site captures the
 * first touch (utm / gclid / fbclid / external referrer) and this app, living
 * on a different subdomain, forwards it to the backend at signup. Returns an
 * empty object when the cookie is absent or malformed.
 *
 * Spread the result into the org-create payload BEFORE any explicit
 * `utm_source` from the URL, so a URL-provided `utm_source` still wins while
 * `gclid` / `fbclid` / `referrer` come only from the cookie.
 */

export function getAttributionFromCookie() {
  var raw = Cookies.get(ATTRIBUTION_COOKIE);
  if (!raw) return {};

  try {
    var parsed = JSON.parse(raw);
    var fields = {};

    var _iterator = _createForOfIteratorHelper(ATTRIBUTION_KEYS),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        var value = parsed[key];
        if (typeof value === 'string' && value) fields[key] = value;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return fields;
  } catch (_unused) {
    return {};
  }
}